export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="border-b border-slate-200 bg-white px-6 md:px-8 py-6 flex items-start justify-between gap-4">
      <div>
        <div className="label-cap mb-1">{subtitle || "\u00a0"}</div>
        <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight text-slate-900" data-testid="page-title">
          {title}
        </h1>
      </div>
      <div className="flex items-center gap-2">{actions}</div>
    </div>
  );
}

export function Section({ children, className = "" }) {
  return <div className={`p-6 md:p-8 ${className}`}>{children}</div>;
}

export function StatusPill({ status }) {
  const map = {
    ordered:      "bg-emerald-100 text-emerald-800 border-emerald-200",
    picking_done: "bg-amber-100 text-amber-800 border-amber-200",
    scanned:      "bg-blue-100 text-blue-800 border-blue-200",
    packed:       "bg-violet-100 text-violet-800 border-violet-200",
    dispatched:   "bg-slate-800 text-white border-slate-800",
    no_stock:     "bg-rose-100 text-rose-800 border-rose-200",
  };
  const label = {
    ordered: "Ordered", picking_done: "Picked", scanned: "Scanned",
    packed: "Packed", dispatched: "Dispatched", no_stock: "No Stock",
  }[status] || status;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-semibold uppercase tracking-wider border rounded-sm ${map[status] || "bg-slate-100 text-slate-700 border-slate-200"}`}>
      {label}
    </span>
  );
}
